"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const i18next_1 = __importDefault(require("i18next"));
function default_1() {
    const THIRTY_MIN = 30 * 60 * 1000;
    (0, react_1.useEffect)(() => {
        const sessionExpired = () => {
            alert(i18next_1.default.t('인증이 만료되었습니다.'));
            window.location.replace('/login');
        };
        const expirationTimer = window.setTimeout(sessionExpired, THIRTY_MIN);
        return () => window.clearTimeout(expirationTimer);
    }, []);
}
exports.default = default_1;
